var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdministratorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 63,
    viewBox: "0 0 51 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#52C9F4",
    fillOpacity: 0.272
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.346 5.381l-9.903 8.447a.406.406 0 0 1-.454.028l-.298-.172a.41.41 0 0 1-.206-.406L41.715.407a.38.38 0 0 1 .223-.288.415.415 0 0 1 .375.02l7.962 4.596c.115.066.19.184.204.31a.383.383 0 0 1-.133.336M8.947 57.7l9.903-8.447a.406.406 0 0 1 .454-.028l.298.172a.41.41 0 0 1 .206.406l-2.23 12.871a.38.38 0 0 1-.223.288.415.415 0 0 1-.375-.02l-7.963-4.596a.412.412 0 0 1-.203-.31.383.383 0 0 1 .133-.336"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC9A2",
    d: "M18.716 20.984a7.585 7.585 0 0 1 3.482 8.718L19.893 37.5a9 9 0 0 1-13.13 5.244l-.915-.528a9 9 0 0 1-2.024-13.994l5.6-5.894a7.585 7.585 0 0 1 9.292-1.344zm-3.222 5.98a2.252 2.252 0 0 0 3.073-.84 2.252 2.252 0 0 0-.81-3.08 2.252 2.252 0 0 0-3.072.839 2.252 2.252 0 0 0 .81 3.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE89E",
    d: "M8.881 36.95l-2.45-.087a.75.75 0 0 1-.552-1.228l1.584-1.911-.661-2.39a.75.75 0 0 1 1-.898l2.288.909 2.044-1.377a.75.75 0 0 1 1.168.674l-.17 2.459 1.93 1.527a.75.75 0 0 1-.277 1.314l-2.4.623-.864 2.328a.75.75 0 0 1-1.339.136l-1.3-2.079z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#404042",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.78 42.617l-.948-.547C1.544 39.595.095 34.078 2.595 29.748a9.138 9.138 0 0 1 1.29-1.725l5.501-5.79a7.677 7.677 0 0 1 3.952-2.224m6.625 1.739a7.639 7.639 0 0 1 2.22 7.872l-2.264 7.66"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#404042",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.177 35.68a.757.757 0 0 1-.405.266l-2.387.62-.863 2.323a.754.754 0 0 1-.963.45.74.74 0 0 1-.373-.303L8.881 36.95l-2.458-.087a.743.743 0 0 1-.716-.779.76.76 0 0 1 .175-.452l1.58-1.908-.656-2.378a.76.76 0 0 1 .521-.93.744.744 0 0 1 .48.023l2.283.906 2.052-1.382a.744.744 0 0 1 1.16.67l-.17 2.468M14.657 23.2a2.252 2.252 0 0 0-.016 3.185 2.252 2.252 0 0 0 3.185-.015c.364-.364.58-.82.645-1.292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE89E",
    d: "M36.921 21.315a7.588 7.588 0 0 1 1.486 8.045l11.031 11.83c.162.174.23.415.186.65l-.413 2.138a.76.76 0 0 1-.654.61l-2.162.262a.745.745 0 0 1-.635-.23l-2.313-2.48a.742.742 0 0 1-.193-.413l-.173-1.364a.741.741 0 0 0-.592-.635l-1.348-.267a.742.742 0 0 1-.399-.222l-3.124-3.35a.745.745 0 0 0-.652-.228l-2.256.326a.745.745 0 0 1-.652-.228l-1.67-1.792a7.588 7.588 0 0 1-6.501-2.362c-2.857-3.064-2.703-7.85.344-10.692a7.496 7.496 0 0 1 5.16-2.019"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#404042",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M36.921 21.315a7.588 7.588 0 0 1 1.486 8.045l11.031 11.83c.162.174.23.415.186.65l-.413 2.138a.76.76 0 0 1-.654.61l-2.162.262a.745.745 0 0 1-.635-.23l-2.313-2.48a.742.742 0 0 1-.193-.413l-.173-1.364a.741.741 0 0 0-.592-.635l-1.348-.267a.742.742 0 0 1-.399-.222l-3.124-3.35a.745.745 0 0 0-.652-.228l-2.256.326a.745.745 0 0 1-.652-.228l-1.67-1.792a7.588 7.588 0 0 1-6.501-2.362c-2.857-3.064-2.703-7.85.344-10.692a7.485 7.485 0 0 1 2.548-1.565"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M31.97 25.672c2.277-3.943.894-9.003-3.088-11.302-3.981-2.299-9.055-.966-11.331 2.977a8.187 8.187 0 0 0-.682 6.67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#404042",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M31.97 25.672c2.277-3.943.894-9.003-3.088-11.302-3.981-2.299-9.055-.966-11.331 2.977a8.187 8.187 0 0 0-.682 6.67"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministratorIcon);
export default __webpack_public_path__ + "static/media/administrator_icon.4a4f703978ac8e3d37cfd38bdec80a21.svg";
export { ForwardRef as ReactComponent };